import SectionHero from "../sectionHeroHome";
import RunningText from "../runningText";
import "../../css/homePage.scss";

const HomePage = (props) => {
  return (
    <>
      <main className="home-page">
        <SectionHero {...props.hero} isPreFillRad={true} />
        <RunningText />
      </main>
    </>
  );
};

export default HomePage;
